import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Input from '../core/input';
import NetworkSelect from './network-select';
import ProviderSelect from './provider-select';
import SubmitButton from '../core/submit-button';

// Styles
import './external-network-form.scss';

function ExternalNetworkForm({editing, formName, onReset}) {
    const handleCancelClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        onReset();
    };

    const getFormProps = () => ({
        editing: !!editing,
        fixedPositionedResponse: true,
        formLabel: 'ExternalNetwork',
        name: formName,
        onReset: () => handleCancelClick(),
        resetOnSubmit: !editing,
        submitData: true,
    });

    return (
        <Form {...getFormProps()}>
            <div className="external-network-form--input-fields">
                <Input label="external network name" name="externalNetworkName" />
                <ProviderSelect label="Provider" multi={false} name="partnerId" />
                <NetworkSelect label="Network" name="networkId" networkId={true} singleSelect={true} />
            </div>
            <div className="external-network-form--button">
                <SubmitButton label="Save" />
                <Button className="external-network-form--cancel-button" onClick={handleCancelClick}>
                    Clear
                </Button>
            </div>
        </Form>
    );
}

ExternalNetworkForm.propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    formName: PropTypes.string,
    onReset: PropTypes.func,
};

export default ExternalNetworkForm;
